const KEY = "chronos.player.v1";
const FAMILY_KEY = "chronos.family.v1";
const USAGE_KEY_PREFIX = "chronos.usage.";  // + YYYY-MM-DD.playerId = seconds

export function saveLocalPlayer(player) {
  try { localStorage.setItem(KEY, JSON.stringify(player)); } catch (e) { /* ignore */ }
}

export function loadLocalPlayer() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) { return null; }
}

export function clearLocalPlayer() {
  try { localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
}

export function saveLocalFamily(familyId) {
  try { localStorage.setItem(FAMILY_KEY, familyId); } catch (e) { /* ignore */ }
}

export function loadLocalFamily() {
  try { return localStorage.getItem(FAMILY_KEY); } catch (e) { return null; }
}

function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function readTodayUsageSeconds(playerId) {
  try {
    const raw = localStorage.getItem(`${USAGE_KEY_PREFIX}${todayKey()}.${playerId}`);
    return raw ? parseInt(raw, 10) : 0;
  } catch (e) { return 0; }
}

export function addTodayUsageSeconds(playerId, seconds) {
  try {
    const k = `${USAGE_KEY_PREFIX}${todayKey()}.${playerId}`;
    const current = parseInt(localStorage.getItem(k) || "0", 10);
    localStorage.setItem(k, String(current + Math.max(0, seconds)));
  } catch (e) { /* ignore */ }
}
